import { render } from "./ViewNatalChartWidget.vue?vue&type=template&id=5cad36df"
import script from "./ViewNatalChartWidget.vue?vue&type=script&lang=js"
export * from "./ViewNatalChartWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__